export default __webpack_public_path__ + "static/media/tw.4ef63f27.png";